import { Box, Typography } from "@mui/material";
import React, {useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./defineSlice";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export default function ChartTableToggle() {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const [isGraphicalView, setIsGraphicalView] = useState(true);

   const { showChart } = define;

   function toggle() {
      dispatch(setState("showChart", !showChart));
   }

   return (
      <Box 
         sx={{ width: 300, display: "flex", justifyContent: "space-between" }} 
      >  
         {/* <Typography
            variant={showChart ? "p16w700" : "p16w400"}
            onClick={toggle}
            sx={{backgroundColor: "#efefef", p: 1, pl: 3, borderRadius: "30px 0 0 30px", cursor: "pointer"}}
         >
            Graph
         </Typography >
         <Typography sx={{backgroundColor: "#efefef", p: 1, py: 2}}>&nbsp;|&nbsp;</Typography> 
         <Typography
            variant={showChart ? "p16w400" : "p16w700"}
            onClick={toggle}
            sx={{backgroundColor: "#efefef", p:1, py: 2, pr: 3, borderRadius: "0 30px 30px 0", cursor: "pointer"}}
         >
         
            Table
         </Typography> */}
         <div className="toggle-container">
            <button
            className={`toggle-button ${showChart ? 'active' : ''}`}
            onClick={() => toggle()}
            >
            Graphical View
            </button>
            <button
            className={`toggle-button ${!showChart ? 'active' : ''}`}
            onClick={() => toggle()}
            >
            Table View
            </button>
         </div>
      </Box>
   );
}
